import { render, staticRenderFns } from "./FieldEditGlobal.vue?vue&type=template&id=2f251c8d&"
import script from "./FieldEditGlobal.vue?vue&type=script&lang=js&"
export * from "./FieldEditGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports